"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarTable = exports.fragments = void 0;
var React = __importStar(require("react"));
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var Appointment = __importStar(require("./appointment"));
var Actions = __importStar(require("../calendar-actions"));
var styled_components_1 = __importDefault(require("styled-components"));
var date_utils_1 = require("../../date-utils");
var StyledCalendarTable = styled_components_1.default.table(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 20px;\n  margin-right: 5px;\n  font-size: 0.8rem;\n  border-width: 1px;\n  background-color: ", ";\n  border: solid 1px ", ";\n  border-spacing: 0px;\n  width: 100%;\n"], ["\n  margin-top: 20px;\n  margin-right: 5px;\n  font-size: 0.8rem;\n  border-width: 1px;\n  background-color: ", ";\n  border: solid 1px ", ";\n  border-spacing: 0px;\n  width: 100%;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.background;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.border;
});
var StyledTableRow = styled_components_1.default.tr(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border: 1px solid ", ";\n"], ["\n  border: 1px solid ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.borderHighContrast;
});
var PersonDiv = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 1rem;\n  padding: 0.5em;\n  @media (max-width: 600px) {\n    font-size: 0.9rem;\n  }\n"], ["\n  font-size: 1rem;\n  padding: 0.5em;\n  @media (max-width: 600px) {\n    font-size: 0.9rem;\n  }\n"])));
var CalendarTableCell = styled_components_1.default.td(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  padding: 2px;\n  text-align: ", ";\n  border: ", ";\n  background-color: ", ";\n  ", "\n"], ["\n  ", ";\n  padding: 2px;\n  text-align: ", ";\n  border: ", ";\n  background-color: ", ";\n  ", "\n"])), function (props) { return (props.sticky ? "position:sticky; left: 0px;" : ""); }, function (props) { var _a; return (_a = props.align) !== null && _a !== void 0 ? _a : "left"; }, function (props) {
    return props.isToday ? "1px solid ".concat(props.theme.colors.divid) : "solid 1px ".concat(props.theme.colors.border);
}, function (props) {
    return props.isToday ? props.theme.colors.currentDayHighlight : props.theme.colors.background;
}, function (props) {
    return props.editable &&
        "&:hover {\n      background-color:".concat(props.theme.colors.accent, ";\n    }\n  ");
});
var CalendarTableCellContent = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding: 0.5em;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding: 0.5em;\n  align-items: center;\n"])));
var FormattedDateSpan = styled_components_1.default.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-size: 1rem;\n  color: ", ";\n  @media (max-width: 600px) {\n    font-size: 0.9rem;\n  }\n"], ["\n  font-size: 1rem;\n  color: ", ";\n  @media (max-width: 600px) {\n    font-size: 0.9rem;\n  }\n"])), function (props) { return (props.sunday ? props.theme.colors.sundayText : props.theme.colors.body); });
var DayNameSpan = styled_components_1.default.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  vertical-align: top;\n  font-size: 1rem;\n  color: ", ";\n  @media (max-width: 600px) {\n    font-size: 0.9rem;\n  }\n"], ["\n  vertical-align: top;\n  font-size: 1rem;\n  color: ", ";\n  @media (max-width: 600px) {\n    font-size: 0.9rem;\n  }\n"])), function (props) { return (props.sunday ? props.theme.colors.sundayText : props.theme.colors.body); });
exports.fragments = {
    calendar: (0, graphql_tag_1.default)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    fragment CalendarTable_Calendar on Calendar {\n      persons {\n        id\n        firstName\n        appointments(year: $year, month: $month) {\n          start\n          end\n          ...Appointment_Appointment\n        }\n      }\n    }\n    ", "\n  "], ["\n    fragment CalendarTable_Calendar on Calendar {\n      persons {\n        id\n        firstName\n        appointments(year: $year, month: $month) {\n          start\n          end\n          ...Appointment_Appointment\n        }\n      }\n    }\n    ", "\n  "])), Appointment.fragments.appointment),
};
function CalendarTable(_a) {
    var calendar = _a.calendar, month = _a.month, year = _a.year, dispatch = _a.dispatch, requery = _a.requery, personFilter = _a.personFilter;
    var todayCellRef = React.useRef(null);
    var tableHeaderRef = React.useRef(null);
    React.useEffect(function () {
        var _a;
        (_a = todayCellRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
    }, []);
    var handleScroll = React.useCallback(function (_) {
        if (tableHeaderRef.current === null) {
            return;
        }
        var theRef = tableHeaderRef.current;
        // reset translation to get original pos
        theRef.style.transform = "";
        var yBeforeTranslate = theRef.getBoundingClientRect().top;
        // If y is negative. We're outside of the viewport.
        if (yBeforeTranslate < 0) {
            // Just translate the object +y to get it to the top of the viewport
            theRef.style.transform = "translate(0," + Math.abs(yBeforeTranslate) + "px)";
        }
        else {
            theRef.style.transform = "";
        }
    }, []);
    React.useEffect(function () {
        window.addEventListener("scroll", handleScroll);
        return function () {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [handleScroll]);
    var daysInMonth = (0, date_utils_1.getDaysInMonth)(year, month - 1);
    return (React.createElement(StyledCalendarTable, null,
        React.createElement("thead", null,
            React.createElement("tr", null,
                React.createElement(CalendarTableCell, null, "Vecka"),
                daysInMonth.map(function (d, index) {
                    var weekDay = (0, date_utils_1.getWeekDay)(year, month - 1, d);
                    return (React.createElement(CalendarTableCell, { align: "center", key: index }, weekDay === 1 && React.createElement("span", null,
                        "v",
                        (0, date_utils_1.ISO8601_week_no)(year, month, d))));
                })),
            React.createElement("tr", { ref: tableHeaderRef },
                React.createElement(CalendarTableCell, null),
                daysInMonth.map(function (d, index) { return (React.createElement(CalendarRow, { year: year, month: month, dayInMonth: d, todayRef: todayCellRef, key: index })); }))),
        React.createElement("tbody", null, calendar.persons.filter(personFilter).map(function (person) { return (React.createElement(StyledTableRow, { key: person.id },
            React.createElement(CalendarTableCell, { sticky: true },
                React.createElement(PersonDiv, null, person.firstName)),
            daysInMonth.map(function (day, index) { return (React.createElement(UserAppointmentCells, { dispatch: dispatch, requery: requery, year: year, month: month, dayInMonth: day, person: person, key: index })); }))); }))));
}
exports.CalendarTable = CalendarTable;
function CalendarRow(_a) {
    var year = _a.year, month = _a.month, dayInMonth = _a.dayInMonth, todayRef = _a.todayRef;
    var weekDay = (0, date_utils_1.getWeekDay)(year, month - 1, dayInMonth);
    var isToday = (0, date_utils_1.isTodaysDate)(year, month - 1, dayInMonth);
    return (
    // tslint:disable-next-line:no-any
    React.createElement(CalendarTableCell, { ref: isToday ? todayRef : null, isToday: isToday },
        React.createElement(CalendarTableCellContent, null,
            React.createElement(FormattedDateSpan, { sunday: weekDay === 0 }, dayInMonth),
            React.createElement(DayNameSpan, { sunday: weekDay === 0 },
                (0, date_utils_1.getWeekDayName)(year, month - 1, dayInMonth),
                " "))));
}
function UserAppointmentCells(_a) {
    var dispatch = _a.dispatch, requery = _a.requery, year = _a.year, month = _a.month, dayInMonth = _a.dayInMonth, person = _a.person;
    var date = (0, date_utils_1.getDate)(year, month - 1, dayInMonth);
    var appointments = person.appointments.filter(function (a) {
        return (0, date_utils_1.isWithin)(year, month - 1, dayInMonth, (0, date_utils_1.unixTimeToDate)(a.start), (0, date_utils_1.unixTimeToDate)(a.end));
    });
    return (React.createElement(CalendarTableCell, { isToday: (0, date_utils_1.isTodaysDate)(year, month - 1, dayInMonth), editable: true, onClick: function () {
            dispatch(Actions.openAppointmentDialog(undefined, person.id, person.firstName, date, date, ""));
        } }, appointments.map(function (a) { return (React.createElement(Appointment.Appointment, { key: a.id, appointment: a, dispatch: dispatch, personId: person.id, userName: person.firstName, requery: requery })); })));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=calendar-table.js.map